
import UserSettings from "../components/UserSettings";
import NotLoggedIn from "../components/NotLoggedIn";
import { Helmet } from "react-helmet"


export default function Settings() {

  return (
    <>
    <Helmet>
        <title>My Account - Sahla Curtain Center</title>
      </Helmet>
     {
      localStorage.getItem("token") ? <UserSettings/> : <NotLoggedIn/>
     }
    </>
)
}